"use client";

import { createContext, useContext, type ReactNode } from "react";
import type { AuthFeatures } from "@/shared/lib/features";

/**
 * Контекст флагов окружения для клиентских компонентов.
 * Заполняется на сервере (app/layout.tsx) значениями из .env, чтобы UI мог
 * скрывать/деактивировать функции, недоступные без настройки (почта, Discord).
 */
const ConfigContext = createContext<AuthFeatures>({ mail: true, discord: true });

export function ConfigProvider({
  features,
  children,
}: {
  features: AuthFeatures;
  children: ReactNode;
}) {
  return <ConfigContext.Provider value={features}>{children}</ConfigContext.Provider>;
}

/** Флаги доступности функций (почта, Discord) */
export function useConfig(): AuthFeatures {
  return useContext(ConfigContext);
}
